import script from "./AddUpdateQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUpdateQuestion.vue?vue&type=script&setup=true&lang=js"

export default script